var ATFCubeTexture = (function () {
    function ATFCubeTexture() {
    }
    return ATFCubeTexture;
}());
export { ATFCubeTexture };
